import { render, staticRenderFns } from "./c_home_comb_cards.vue?vue&type=template&id=6f51a21d&scoped=true"
import script from "./c_home_comb_cards.vue?vue&type=script&lang=js"
export * from "./c_home_comb_cards.vue?vue&type=script&lang=js"
import style0 from "./c_home_comb_cards.vue?vue&type=style&index=0&id=6f51a21d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f51a21d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f51a21d')) {
      api.createRecord('6f51a21d', component.options)
    } else {
      api.reload('6f51a21d', component.options)
    }
    module.hot.accept("./c_home_comb_cards.vue?vue&type=template&id=6f51a21d&scoped=true", function () {
      api.rerender('6f51a21d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_home_comb_cards.vue"
export default component.exports